export default __webpack_public_path__ + "static/template-about-hero-background-5ff856c73da908d9bd55b27214c06c28.jpg";